export function getNextPageParam(lastPage: any) {
  const { current_page, last_page } = lastPage.metadata.pagination;
  const nextPageIndex = current_page + 1;

  return current_page === last_page ? undefined : nextPageIndex;
}
